var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M2.95938 13.2812H13.6036C13.8604 13.2812 14.0732 13.4938 14.0732 13.75C14.0732 14.0063 13.8604 14.2188 13.6036 14.2188H2.95938C2.70266 14.2188 2.48978 14.0063 2.48978 13.75C2.48978 13.4938 2.70266 13.2812 2.95938 13.2812Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M12.6642 9.075C12.4075 9.075 12.1946 8.8625 12.1946 8.60625V3.31875L4.23017 11.2688C4.13625 11.3625 4.01729 11.4062 3.89832 11.4062C3.77936 11.4062 3.66039 11.3625 3.56647 11.2688C3.38489 11.0875 3.38489 10.7875 3.56647 10.6062L11.5309 2.65625H6.2338C5.97709 2.65625 5.7642 2.44375 5.7642 2.1875C5.7642 1.93125 5.97709 1.71875 6.2338 1.71875H12.6642C12.7268 1.71875 12.7832 1.73125 12.8458 1.75625C12.9585 1.8 13.0524 1.89375 13.0962 2.00625C13.1213 2.06875 13.1338 2.125 13.1338 2.1875V8.60625C13.1338 8.8625 12.9209 9.075 12.6642 9.075Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }